/**
 * Test IDs for QA automation.
 */
export const testIds = {
  driverSettlementListOpen: "driver-settlement-list-open",
  driverSettlementListDriver: "driver-settlement-list-driver",
  driverSettlementListSettlementDocument: "driver-settlement-list-settlement-document",
  driverSettlementListNotSettledNavigation: "driver-settlement-list-not-settled-navigation",
  driverSettlementListNotSettledView: "driver-settlement-list-not-settled-view",
  driverSettlementListInProcess: "driver-settlement-list-in-process",
  driverSettlementListReleased: "driver-settlement-list-released",
  driverSettlementListOnHold: "driver-settlement-list-on-hold",
  driverSettlementListHistory: "driver-settlement-list-history",
} as const;
